// extracted by mini-css-extract-plugin
module.exports = {"transitionContainer":"ExpertiseAreas_transitionContainer__K2dQ4","expertiseWrapper":"ExpertiseAreas_expertiseWrapper__Db8nn"};